import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class AddTopBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: "",
      url: "",
      name: "",
      pincode: "",
      submissionStatus: null,
      currentImageUrl: null,
      submit: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
  }


  // handleChange = (e) => {
  //   const file = e.target.files[0];
  //   const errors = [];

  //   if (file) {
  //     const img = new Image();
  //     img.src = URL.createObjectURL(file);

  //     img.onload = () => {
  //       const { width, height } = img;
  //       if (file.size > this.state.maxSize) {
  //         errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
  //       } else if (width !== 1500 || height !== 750) {
  //         errors.push(`Image size should be exactly 1500x750 pixels.`);
  //       } else {
  //         this.setState({
  //           image: file,
  //           currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
  //           errors: []
  //         });
  //       }
  //     };

  //     img.onerror = () => {
  //       errors.push("Invalid image file.");
  //       this.setState({ errors });
  //     };
  //   }

  //   this.setState({ errors });
  // };

   handleChange = (e) => {
    const file = e.target.files[0];
    const errors = [];

    if (file) {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
        this.setState({
          image: "", // Clear image if too large
          currentImageUrl: null,
          errors: errors
        });
      } else {
        // If file size is valid, set the image and create URL
        this.setState({
          image: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
          errors: [] // Clear any previous errors
        });
      }
    } else {
      // If no file is selected (e.g., user opens and closes file dialog)
      this.setState({
        image: "",
        currentImageUrl: null,
        errors: []
      });
    }
  };

  onChange = (e) => {
    this.setState({ url: e.target.value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submit: true });

    const { image, name, pincode, url } = this.state;

    if (!image || !name.trim() || !url.trim()) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append('image', image);
      formData.append('name', name);
      if (pincode.trim()) {
        formData.append('pincode', pincode);
      }
      formData.append('url', url); // Include URL in formData

      // Log FormData contents
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await axios.post("https://samaj.aasmo.in/api/admin/banners", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
      });

      if (response.status === 201) {
        this.setState({ submissionStatus: 'success', submit: false });
        setTimeout(() => {
          this.props.history.push("/topbannerlist");
        }, 2000);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
      this.setState({ submissionStatus: 'error' });
    }
  };



  render() {
    const { image, name, pincode, submit, currentImageUrl, submissionStatus, errors } = this.state;
    const isNameValid = name.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add Top Banner</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                {/* <label>Banner Image (1500x750 pixels)</label> */}
                <label>Banner Image</label>
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!image && submit && "parsley-error"}`}
                  name="image"
                  required
                  onChange={this.handleChange}
                />
                {!image && submit ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
                {errors.length > 0 && (
                  <ul className="parsley-errors-list filled">
                    {errors.map((error, index) => (
                      <li key={index} className="parsley-required">
                        {error}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="form-group">
                <label>Banner Name</label>
                <input
                  className={`form-control ${!isNameValid && submit && "parsley-error"}`}
                  value={name}
                  name="name"
                  required
                  type="text"
                  onChange={(e) => {
                    this.setState({ name: e.target.value });
                  }}
                />
                {!isNameValid && submit ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Pincode (Optional)</label>
                <input
                  className="form-control"
                  value={pincode}
                  name="pincode"
                  type="text"
                  onChange={(e) => {
                    this.setState({ pincode: e.target.value });
                  }}
                />
              </div>
              <div className="form-group">
                <label>URL</label>
                <input
                  className={`form-control ${!this.state.url.trim() && submit && "parsley-error"}`}
                  value={this.state.url}
                  name="url"
                  required
                  type="text"
                  onChange={(e) => {
                    this.setState({ url: e.target.value });
                  }}
                />
                {!this.state.url.trim() && submit ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              {submissionStatus === 'error' && (
                <div className="alert alert-danger" role="alert">
                  An error occurred. Please try again.
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(connect(mapStateToProps, { notifyGeneralInfo })(AddTopBanner));
